// dark/primary
export var getLightStatusColors = function getLightStatusColors(status) {
  return {
    primary: {
      n: {
        c: 'background',
        bg: status
      },
      h: {
        c: 'background',
        bg: "".concat(status, "_80")
      },
      a: {
        c: 'background',
        bg: "".concat(status, "_120")
      }
    },
    secondary: {
      n: {
        c: status,
        bg: "".concat(status, "_10"),
        bd: "".concat(status, "_30")
      },
      h: {
        c: "".concat(status, "_80"),
        bg: "".concat(status, "_10"),
        bd: "".concat(status, "_20")
      },
      a: {
        c: status,
        bg: "".concat(status, "_30"),
        bd: "".concat(status, "_50")
      }
    },
    outlinecolor: {
      n: {
        c: status,
        bg: 'background',
        bd: "".concat(status, "_50")
      },
      h: {
        c: "".concat(status, "_80"),
        bg: 'background',
        bd: "".concat(status, "_30")
      },
      a: {
        c: "".concat(status, "_120"),
        bg: 'background',
        bd: "".concat(status, "_80")
      }
    },
    outlinebw: {
      n: {
        c: 'primary',
        bg: 'base',
        bd: 'fourth'
      },
      h: {
        c: 'third',
        bg: 'base',
        bd: 'fourth'
      },
      a: {
        c: 'primary',
        bg: 'fifth',
        bd: 'fourth'
      }
    },
    link: {
      n: {
        c: status
      },
      h: {
        c: "".concat(status, "_80")
      },
      a: {
        c: "".concat(status, "_120"),
        bg: "".concat(status, "_10")
      }
    },
    text: {
      n: {
        c: 'primary'
      },
      h: {
        c: 'third'
      },
      a: {
        c: 'primary',
        bg: 'fifth'
      }
    }
  };
};
export var getDarkStatusColors = function getDarkStatusColors(status) {
  return {
    primary: {
      n: {
        c: 'primary',
        bg: "".concat(status, "_80")
      },
      h: {
        c: 'primary',
        bg: status
      },
      a: {
        c: 'primary',
        bg: "".concat(status, "_60")
      }
    },
    secondary: {
      n: {
        c: status,
        bg: "".concat(status, "_10"),
        bd: "".concat(status, "_30")
      },
      h: {
        c: "".concat(status, "_120"),
        bg: "".concat(status, "_30"),
        bd: "".concat(status, "_50")
      },
      a: {
        c: "".concat(status, "_80"),
        bg: "".concat(status, "_10"),
        bd: "".concat(status, "_20")
      }
    },
    outlinecolor: {
      n: {
        c: status,
        bg: 'background',
        bd: "".concat(status, "_50")
      },
      h: {
        c: "".concat(status, "_120"),
        bg: 'background',
        bd: "".concat(status, "_80")
      },
      a: {
        c: "".concat(status, "_80"),
        bg: 'background',
        bd: "".concat(status, "_50")
      }
    },
    outlinebw: {
      n: {
        c: 'secondary',
        bg: 'base',
        bd: 'fourth'
      },
      h: {
        c: 'primary',
        bg: 'fifth',
        bd: 'third'
      },
      a: {
        c: 'secondary',
        bg: 'base',
        bd: 'fifth'
      }
    },
    link: {
      n: {
        c: status
      },
      h: {
        c: "".concat(status, "_120")
      },
      a: {
        c: "".concat(status, "_80"),
        bg: "".concat(status, "_10")
      }
    },
    text: {
      n: {
        c: 'secondary'
      },
      h: {
        c: 'primary'
      },
      a: {
        c: 'secondary',
        bg: 'fifth'
      }
    }
  };
};
export var getDarkDangerColors = function getDarkDangerColors(status) {
  return {
    primary: {
      n: {
        c: 'primary',
        bg: status
      },
      h: {
        c: 'primary',
        bg: "".concat(status, "_120")
      },
      a: {
        c: 'primary',
        bg: "".concat(status, "_80")
      }
    },
    secondary: {
      n: {
        c: status,
        bg: "".concat(status, "_10"),
        bd: "".concat(status, "_30")
      },
      h: {
        c: "".concat(status, "_120"),
        bg: "".concat(status, "_10"),
        bd: "".concat(status, "_20")
      },
      a: {
        c: "".concat(status, "_80"),
        bg: "".concat(status, "_10"),
        bd: "".concat(status, "_20")
      }
    },
    outlinecolor: {
      n: {
        c: status,
        bg: 'background',
        bd: "".concat(status, "_50")
      },
      h: {
        c: "".concat(status, "_120"),
        bg: 'background',
        bd: "".concat(status, "_80")
      },
      a: {
        c: "".concat(status, "_80"),
        bg: 'background',
        bd: "".concat(status, "_50")
      }
    },
    outlinebw: {
      n: {
        c: 'secondary',
        bg: 'base',
        bd: 'fourth'
      },
      h: {
        c: 'third',
        bg: 'base',
        bd: 'fourth'
      },
      a: {
        c: 'primary',
        bg: 'fifth',
        bd: 'fourth'
      }
    },
    link: {
      n: {
        c: status
      },
      h: {
        c: "".concat(status, "_120")
      },
      a: {
        c: "".concat(status, "_80"),
        bg: "".concat(status, "_10")
      }
    },
    text: {
      n: {
        c: 'secondary'
      },
      h: {
        c: 'third'
      },
      a: {
        c: 'primary',
        bg: 'fifth'
      }
    }
  };
};
export var disabledLightColorConfig = {
  primary: {
    n: {
      c: 'background',
      bg: 'fourth'
    }
  },
  secondary: {
    n: {
      c: 'fourth',
      bg: 'base',
      bd: 'fifth'
    }
  },
  outlinecolor: {
    n: {
      c: 'fourth',
      bg: 'background',
      bd: 'fifth'
    }
  },
  outlinebw: {
    n: {
      c: 'fourth',
      bg: 'base',
      bd: 'fifth'
    }
  },
  link: {
    n: {
      c: 'fourth'
    }
  },
  text: {
    n: {
      c: 'fourth'
    }
  }
};
export var disabledDarkColorConfig = {
  primary: {
    n: {
      c: 'third',
      bg: 'fourth'
    }
  },
  secondary: {
    n: {
      c: 'fourth',
      bg: 'base',
      bd: 'fifth'
    }
  },
  outlinecolor: {
    n: {
      c: 'fourth',
      bg: 'background',
      bd: 'fifth'
    }
  },
  outlinebw: {
    n: {
      c: 'fourth',
      bg: 'base',
      bd: 'fifth'
    }
  },
  link: {
    n: {
      c: 'fourth'
    }
  },
  text: {
    n: {
      c: 'fourth'
    }
  }
};